<script>
	// 폰(<768px) 전용 상단 가로 탭바. 넘치면 좌우 스크롤. 태블릿/데스크톱은 좌측 BuilderSidebar 사용.
	// 탭 로직은 chat(Chat 인스턴스) 소유 — 여긴 표현만. BuilderSidebar와 동일한 visibleTabs 규칙.
	export let chat;
	export let tabList = [];
	import { V3_ONLY_TABS } from "./tabs";

	$: visibleTabs = tabList.filter((t) => !V3_ONLY_TABS.includes(t.value) || chat.chatVersion === "V3");
</script>

<nav
	class="tw-flex tw-shrink-0 tw-gap-1 tw-overflow-x-auto tw-border-b tw-border-border tw-bg-background tw-px-3 tw-py-2 md:tw-hidden"
	aria-label="빌더 단계"
>
	{#each visibleTabs as tab (tab.value)}
		<button
			type="button"
			class="tw-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-gap-0.5 tw-whitespace-nowrap tw-rounded-full tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-transition-colors {chat.isCurrentTab(
				tab.value,
			)
				? 'tw-bg-primary/10 tw-text-primary'
				: 'tw-text-foreground/70 hover:tw-bg-muted hover:tw-text-foreground'}"
			on:click={() => chat.changeCurrentTab(tab.value)}
		>
			{tab.label}{#if tab.required}<span class="tw-text-destructive">*</span>{/if}
		</button>
	{/each}
</nav>
